export const POST_AUTH_WELCOME = {
  shopify_post_auth: {
    title: "Welcome to Zeqi",
    body:
      "I can help you turn your store data into sharper decisions across performance, conversion, SEO, content, and growth strategy. Since your Shopify store is already connected, connect Google and Meta next so I can give you the full picture.",
    buttonLabel: "Open integrations",
  },
  email_post_auth: {
    title: "Welcome to Zeqi",
    body:
      "We can work together on growth strategy, ads, SEO, reporting, and assessments. Connect Shopify next so I can analyze your real commerce data and serve you much better.",
    buttonLabel: "Connect your store",
  },
  google_post_auth: {
    title: "Welcome to Zeqi",
    body:
      "You're in. Connect Shopify next so I can analyze your store data and build much stronger reporting, assessments, and strategy.",
    buttonLabel: "Connect your store",
  },
  meta_post_auth: {
    title: "Welcome to Zeqi",
    body:
      "I can help you connect ad performance to real business outcomes, but Shopify is the missing half of the story. Connect your store next so I can see what is really driving revenue.",
    buttonLabel: "Connect your store",
  },
};
